import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { isDeepEqual } from 'utils/objectUtils';
import Button from 'components/button/Button';
import { useIsMutating } from '@tanstack/react-query';
import { UnitListSchemaType } from '../PropertySettingsUnitsTab.schema';
import { UNIT_SUBMIT_MUTATION_KEY } from '../useUnitSubmit';
import { SaveButtonContainer } from './ButtonSubmitUnits.styles';

const ButtonSubmitUnits = () => {
  const { t } = useTranslation();
  const {
    watch,
    formState: { defaultValues },
  } = useFormContext<UnitListSchemaType>();
  const units = watch('units');
  const isMutating = useIsMutating({
    mutationKey: UNIT_SUBMIT_MUTATION_KEY,
  });

  const isUpdating = isMutating > 0;

  const shouldDisableSaveButton = useMemo(
    () => isDeepEqual(units, defaultValues?.units),
    [units, defaultValues?.units],
  );

  return (
    <SaveButtonContainer>
      <Button
        type="submit"
        disabled={isUpdating || shouldDisableSaveButton}
        bsStyle="primary"
      >
        {t('pageProperty.units.saveUnits')}
      </Button>
    </SaveButtonContainer>
  );
};

export default ButtonSubmitUnits;
